import { render, staticRenderFns } from "./RicUserShow.vue?vue&type=template&id=7becc406"
import script from "./RicUserShow.vue?vue&type=script&lang=ts"
export * from "./RicUserShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports